import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/empty.vue").then(m => m.default || m)),
  promotion: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/promotion.vue").then(m => m.default || m)),
  stripped: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/stripped.vue").then(m => m.default || m))
}